import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/app/(public)/search/SearchHeroWithApollo.tsx");
